module.exports = __webpack_public_path__ + "static/media/strife.1e032096.svg";